import React, { useEffect } from "react";
import { WizardFormField } from "../machines/immersive-wizard.machine";
import { WizardFormData } from "../types/wizard.types";

interface ScheduleStepProps {
  formData: WizardFormData;
  onFormUpdate: (data: Partial<WizardFormData>) => void;
  onValidationChange: (isValid: boolean) => void;
}

const ScheduleStep: React.FC<ScheduleStepProps> = ({
  formData,
  onFormUpdate,
  onValidationChange,
}) => {
  const hasSelection =
    formData[WizardFormField.AppointmentsEnabled] ||
    formData[WizardFormField.ClassesEnabled];

  useEffect(() => {
    onValidationChange(hasSelection);
  }, [hasSelection, onValidationChange]);

  return (
    <div>
      <label
        htmlFor="schedule-step"
        className="tw-block tw-text-sm tw-font-medium tw-mb-4"
      >
        What type of bookings do you offer?
      </label>
      <div className="tw-grid tw-grid-cols-1 tw-gap-4">
        {/* Appointments Block */}
        <button
          onClick={() =>
            onFormUpdate({
              [WizardFormField.AppointmentsEnabled]:
                !formData[WizardFormField.AppointmentsEnabled],
            })
          }
          className={`tw-p-6 tw-rounded-lg tw-border-2 tw-transition-all tw-text-left tw-w-full ${
            formData[WizardFormField.AppointmentsEnabled]
              ? "tw-bg-neutral-800/10 tw-text-neutral-800 tw-border-neutral-800/40"
              : "tw-bg-neutral-800/5 tw-text-neutral-800 tw-border-neutral-800/20 hover:tw-border-neutral-800/40"
          }`}
        >
          <div className="tw-flex tw-items-center tw-gap-4">
            <div
              className={`tw-w-6 tw-h-6 tw-rounded-full tw-border-2 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 ${
                formData[WizardFormField.AppointmentsEnabled]
                  ? "tw-border-neutral-800 tw-bg-neutral-800"
                  : "tw-border-neutral-800/30"
              }`}
            >
              {formData[WizardFormField.AppointmentsEnabled] && (
                <div className="tw-w-2 tw-h-2 tw-bg-white tw-rounded-full"></div>
              )}
            </div>
            <div>
              <h3 className="tw-text-lg tw-font-semibold tw-mb-1">
                Appointments
              </h3>
              <p className="tw-text-sm tw-text-neutral-800/70">
                1-on-1 sessions, personal training, consultations
              </p>
            </div>
          </div>
        </button>

        {/* Classes Block */}
        <button
          onClick={() =>
            onFormUpdate({
              [WizardFormField.ClassesEnabled]:
                !formData[WizardFormField.ClassesEnabled],
            })
          }
          className={`tw-p-6 tw-rounded-lg tw-border-2 tw-transition-all tw-text-left tw-w-full ${
            formData[WizardFormField.ClassesEnabled]
              ? "tw-bg-neutral-800/10 tw-text-neutral-800 tw-border-neutral-800/40"
              : "tw-bg-neutral-800/5 tw-text-neutral-800 tw-border-neutral-800/20 hover:tw-border-neutral-800/40"
          }`}
        >
          <div className="tw-flex tw-items-center tw-gap-4">
            <div
              className={`tw-w-6 tw-h-6 tw-rounded-full tw-border-2 tw-flex tw-items-center tw-justify-center tw-flex-shrink-0 ${
                formData[WizardFormField.ClassesEnabled]
                  ? "tw-border-neutral-800 tw-bg-neutral-800"
                  : "tw-border-neutral-800/30"
              }`}
            >
              {formData[WizardFormField.ClassesEnabled] && (
                <div className="tw-w-2 tw-h-2 tw-bg-white tw-rounded-full"></div>
              )}
            </div>
            <div>
              <h3 className="tw-text-lg tw-font-semibold tw-mb-1">Classes</h3>
              <p className="tw-text-sm tw-text-neutral-800/70">
                Group sessions, fitness classes, workshops
              </p>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};

export default ScheduleStep;
